import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Nome',
        field: 'nome'
      }, {
        type: 'text',
        label: 'E-mail',
        field: 'email'
      }, {
        type: 'text',
        label: 'CPF/CNPJ',
        field: 'cnpj_cpf'
      }, {
        type: 'date',
        label: 'Data Cadastro',
        field: 'created_at'
      }, {
        type: 'date',
        label: 'Data Vencimento',
        field: 'data_validade'
      }, {
        type: 'select',
        label: 'Tipo',
        field: 'tipo',
        options: ['Cliente', 'Revenda', 'Todos']
      }, {
        type: 'select',
        label: 'Plano',
        field: 'plano',
        options: ['Free', 'Essencial Anual', 'Essencial Mensal', 'Standard Mensal', 'Standard Anual', 'Todos']
      }]
    }
  }), _vm.currentUser.admin ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.clientesNuts",
      modifiers: {
        "clientesNuts": true
      }
    }]
  }, [_vm._v("Relatório Clientes Nuts ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.clientesRevendas",
      modifiers: {
        "clientesRevendas": true
      }
    }]
  }, [_vm._v("Relatório Clientes Revendas ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.clientePorUF",
      modifiers: {
        "clientePorUF": true
      }
    }]
  }, [_vm._v("Relatório Clientes por UF/Cidade ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.clientesMensal",
      modifiers: {
        "clientesMensal": true
      }
    }]
  }, [_vm._v("Relatório Clientes Mensal ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.faturamentoSegmentado",
      modifiers: {
        "faturamentoSegmentado": true
      }
    }]
  }, [_vm._v("Faturamento por tipo ")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "faturamentoSegmentado",
      "title": "Informe o período para o relatório de faturamento",
      "centered": "",
      "size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "faturamentoSegmentado",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.gerarFaturamentoSegmentado
          }
        }, [_vm._v(" Gerar Relatório ")]), _c('b-button', {
          on: {
            "click": cancel
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data Início"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.formFaturamento.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.formFaturamento, "data_inicio", $$v);
      },
      expression: "formFaturamento.data_inicio"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Data Fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.formFaturamento.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.formFaturamento, "data_fim", $$v);
      },
      expression: "formFaturamento.data_fim"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "clientesMensal",
      "title": "Esse relatório será somente dos clientes Nuts Mensal!",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "clientesMensal",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.gerarRelatorioMensal
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "clientesNuts",
      "title": "Esse relatório será somente dos clientes Nuts!",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('div', [_c('b-button', {
          ref: "clientesNuts",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.gerarRelatorioNuts
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "clientePorUF",
      "title": "Esse relatório será somente dos clientes Nuts!",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref4) {
        var ok = _ref4.ok,
          cancel = _ref4.cancel;
        return [_c('div', [_c('b-button', {
          ref: "clientePorUF",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.gerarRelatorioPorUF
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "clientesRevendas",
      "title": "Esse relatório será somente dos clientes das Revendas Nuts!",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref5) {
        var ok = _ref5.ok,
          cancel = _ref5.cancel;
        return [_c('div', [_c('b-button', {
          ref: "clientesRevendas",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.gerarRelatorioRevendasNuts
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }), _c('TableApp', {
    ref: "clientes",
    attrs: {
      "titulo": "Revendas/Clientes",
      "subTitulo": "Nuts",
      "api-url": "empresa/clientes",
      "fields": _vm.fields,
      "classFilterColumn": "clientes",
      "perPage": 10
    },
    on: {
      "loaded": _vm.atualizarResumoPainel
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'nome' ? _c('span', {
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('span', {
          staticClass: "cliente-cell"
        }, [_c('span', {
          staticClass: "cliente-main"
        }, [_vm._v(_vm._s(props.rowData.nome))]), _c('span', {
          staticClass: "cliente-muted"
        }, [_vm._v(" Revenda: " + _vm._s(props.rowData.revenda_nome || "Não informada") + " ")]), props.rowData.fone ? _c('span', {
          staticClass: "cliente-muted"
        }, [_vm._v(" Telefone: " + _vm._s(props.rowData.fone) + " ")]) : _vm._e(), _c('span', {
          staticClass: "cliente-muted"
        }, [_vm._v(" " + _vm._s(_vm.cidadeUfCliente(props.rowData)) + " ")]), props.rowData.revenda ? _c('span', {
          staticClass: "cliente-chip-wrap"
        }, [_c('span', {
          staticClass: "label label-sm label-inline label-light-success"
        }, [_vm._v(" Revenda ")]), props.rowData.revenda_mensal_habilitado ? _c('span', {
          staticClass: "label label-sm label-inline label-light-primary ml-1"
        }, [_vm._v(" Renovação mensal ")]) : _vm._e()]) : _vm._e(), _c('span', {
          staticClass: "d-none"
        }, [_vm._v(_vm._s(_vm.registrarResumoLinha(props.rowData)))])])]) : _vm._e(), props.field == 'cnpj_cpf' ? _c('span', {
          attrs: {
            "slot": "cnpj_cpf"
          },
          slot: "cnpj_cpf"
        }, [_c('span', {
          staticClass: "documento-cell"
        }, [props.rowData.cnpj_cpf ? _c('div', {
          staticClass: "font-weight-bolder font-size-lg mb-0"
        }, [_vm._v(" " + _vm._s(_vm.formatCpfCnpj(props.rowData.cnpj_cpf)) + " ")]) : _vm._e(), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: props.rowData.ie_rg,
            expression: "props.rowData.ie_rg"
          }],
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" IE: " + _vm._s(props.rowData.ie_rg) + " ")])])]) : _vm._e(), props.field == 'data_validade' ? _c('span', {
          attrs: {
            "slot": "data_validade"
          },
          slot: "data_validade"
        }, [_c('div', {
          staticClass: "license-summary-cell licenca-cell"
        }, [_c('div', {
          staticClass: "license-plan-line"
        }, [_c('span', {
          staticClass: "license-plan-badge"
        }, [_vm._v(" " + _vm._s(_vm.siglaPlanoLicenca(props.rowData)) + " ")]), _c('strong', [_vm._v(_vm._s(_vm.nomePlanoLicenca(props.rowData)))])]), _vm.dataValidadeLicenca(props.rowData) ? _c('div', {
          staticClass: "license-muted"
        }, [_vm._v(" Vence: " + _vm._s(_vm.dataValidadeLicenca(props.rowData)) + " ")]) : _vm._e(), _c('div', {
          staticClass: "license-lines"
        }, [_c('div', {
          staticClass: "license-row"
        }, [_c('span', [_vm._v("Plano")]), _c('strong', [_vm._v(" " + _vm._s(_vm.formatarMoedaLicenca(_vm.valorAnualPlanoLicenca(props.rowData))) + "/ano ")])]), _vm.totalAppsAtivosLicenca(props.rowData) > 0 ? [_vm.totalAnualAppsLicenca(props.rowData) > 0 ? _c('div', {
          staticClass: "license-row license-muted"
        }, [_c('span', [_vm._v("Anual apps")]), _c('span', [_vm._v(" " + _vm._s(_vm.formatarMoedaLicenca(_vm.totalAnualAppsLicenca(props.rowData))) + "/ano ")])]) : _vm._e()] : _vm._e()], 2)])]) : _vm._e(), props.field == 'apps' ? _c('span', {
          attrs: {
            "slot": "apps"
          },
          slot: "apps"
        }, [_c('div', {
          staticClass: "apps-cell"
        }, [_vm.totalAppsAtivosLicenca(props.rowData) > 0 ? [_c('div', {
          staticClass: "apps-active-count"
        }, [_vm._v(" " + _vm._s(_vm.totalAppsAtivosLicenca(props.rowData)) + " apps ativos ")]), _c('div', {
          staticClass: "apps-active-names"
        }, [_vm._v(" " + _vm._s(_vm.resumoAppsLicenca(props.rowData)) + " ")]), _c('b-button', {
          staticClass: "mt-2",
          attrs: {
            "size": "sm",
            "variant": "light-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalAppsLicenca(props.rowData);
            }
          }
        }, [_vm._v(" Ver apps ")])] : _vm._e()], 2)]) : _vm._e(), props.field == 'revenda_info' ? _c('span', {
          attrs: {
            "slot": "revenda_info"
          },
          slot: "revenda_info"
        }, [props.rowData.revenda ? _c('div', {
          staticClass: "reseller-info-cell"
        }, [_c('div', {
          staticClass: "reseller-info-line"
        }, [_c('span', [_vm._v("Nível Partner")]), _c('strong', [_vm._v(_vm._s(_vm.nivelPartnerRevenda(props.rowData)))])]), _c('div', {
          staticClass: "reseller-info-line"
        }, [_c('span', [_vm._v("Licenças Nuts")]), _c('strong', [_vm._v(_vm._s(_vm.totalLicencasRevenda(props.rowData)))])])]) : _c('span', {
          staticClass: "license-empty"
        }, [_vm._v("Cliente")])]) : _vm._e(), props.field == 'status' ? _c('span', {
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_c('div', {
          staticClass: "status-cell"
        }, [_c('span', {
          staticClass: "label label-sm label-inline",
          class: _vm.clienteBloqueado(props.rowData) ? 'label-light-danger' : 'label-light-success'
        }, [_vm._v(" " + _vm._s(_vm.clienteBloqueado(props.rowData) ? "Bloqueado" : "Ativo") + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions"
        }, [_c('b-button', {
          staticClass: "row-actions-toggle",
          attrs: {
            "id": "revenda-acoes-".concat(props.rowData.id_empresa),
            "size": "sm",
            "variant": "light-primary",
            "aria-label": "Abrir ações do cliente"
          }
        }, [_c('Menu', {
          staticClass: "mr-1",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Ações ")], 1), _c('b-popover', {
          attrs: {
            "target": "revenda-acoes-".concat(props.rowData.id_empresa),
            "triggers": "click blur",
            "placement": "bottom-end",
            "boundary": "viewport",
            "container": "body",
            "custom-class": "revenda-actions-popover"
          }
        }, [_c('div', {
          staticClass: "revenda-actions-menu"
        }, [_c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                name: 'revendasEditar',
                params: {
                  id_empresa: props.rowData.id_empresa
                }
              });
            }
          }
        }, [_c('Eye', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Visualizar cliente ")], 1), _vm.currentUser.admin && _vm.isNuts ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalFeatures(props.rowData);
            }
          }
        }, [_c('AppsIcon', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Gerenciar módulos e plugins ")], 1) : _vm._e(), _vm.isNuts ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalUsuarios(props.rowData);
            }
          }
        }, [_c('AccountGroup', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Usuários e senhas ")], 1) : _vm._e(), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalPlano(props.rowData);
            }
          }
        }, [_c('CreditCard', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Alterar plano ")], 1), _c('div', {
          staticClass: "dropdown-divider"
        }), _vm.clienteBloqueado(props.rowData) ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.liberarAcesso(props.rowData);
            }
          }
        }, [_c('LockOpen', {
          staticClass: "action-item-icon text-success",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Liberar acesso ")], 1) : _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.bloquearAcesso(props.rowData);
            }
          }
        }, [_c('Lock', {
          staticClass: "action-item-icon text-danger",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Bloquear acesso ")], 1), !props.rowData.revenda ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.tornarRevenda(props.rowData);
            }
          }
        }, [_c('OfficeBuilding', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Tornar revenda ")], 1) : _vm._e(), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.verUsoEmpresa(props.rowData);
            }
          }
        }, [_c('Analytics', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Análise de uso ")], 1), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.setarCreditosUnicheck(props.rowData);
            }
          }
        }, [_c('Cash', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Informar créditos Unicheck ")], 1), props.rowData.revenda ? [_c('div', {
          staticClass: "dropdown-divider"
        }), _vm.isNuts && _vm.currentUser.admin ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalMensalRevenda(props.rowData);
            }
          }
        }, [_c('CreditCard', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Configurar assinatura mensal ")], 1) : _vm._e(), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                name: 'revendasListaClientes',
                params: {
                  id_revenda: props.rowData.id_empresa,
                  rota: 'revendasLista'
                }
              });
            }
          }
        }, [_c('AccountGroup', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Lista de clientes ")], 1), _vm.isNuts ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalSaldoApps(props.rowData);
            }
          }
        }, [_c('Briefcase', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Saldo de Apps da revenda ")], 1) : _vm._e(), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.setarLicencas(props.rowData);
            }
          }
        }, [_c('License', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Informar licenças para revenda ")], 1), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.setarNivel(props.rowData);
            }
          }
        }, [_c('Medal', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Nível Partner ")], 1), _vm.currentUser.admin && _vm.nivelPartnerRevendaNumero(props.rowData) === 5 ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalUploadPdvOffline(props.rowData);
            }
          }
        }, [_c('CloudUpload', {
          staticClass: "action-item-icon",
          attrs: {
            "size": 16
          }
        }), _vm._v(" Upload PDV Offline ")], 1) : _vm._e()] : _vm._e()], 2)])], 1)]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "modal-usuarios-empresa",
      "title": _vm.empresaUsuariosSelecionada ? 'Usuários — ' + _vm.empresaUsuariosSelecionada.nome : 'Usuários da empresa',
      "hide-footer": "",
      "centered": "",
      "size": "lg"
    }
  }, [_vm.loadingUsuarios ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Carregando..."
    }
  }), _c('p', {
    staticClass: "mt-3 text-muted"
  }, [_vm._v("Carregando usuários da empresa...")])], 1) : _vm.erroUsuarios ? _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.erroUsuarios) + " ")]) : !_vm.usuariosEmpresa.length ? _c('div', {
    staticClass: "empty-users-state"
  }, [_vm._v(" Nenhum usuário encontrado para esta empresa. ")]) : _c('div', {
    staticClass: "company-users-list"
  }, _vm._l(_vm.usuariosEmpresa, function (usuario) {
    return _c('div', {
      key: usuario.id_usuario,
      staticClass: "company-user-item"
    }, [_c('div', {
      staticClass: "company-user-info"
    }, [_c('div', {
      staticClass: "d-flex align-items-center flex-wrap"
    }, [_c('strong', [_vm._v(_vm._s(usuario.nome || "Sem nome informado"))]), _c('span', {
      staticClass: "label label-sm label-inline ml-2",
      class: usuario.status === 'A' ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(usuario.status === "A" ? "Ativo" : "Inativo") + " ")]), usuario.admin ? _c('span', {
      staticClass: "label label-sm label-inline label-light-primary ml-2"
    }, [_vm._v(" Administrador ")]) : _vm._e()]), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(usuario.usuario))])]), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirAlteracaoSenha(usuario);
        }
      }
    }, [_vm._v(" Alterar senha ")])], 1);
  }), 0)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-alterar-senha-usuario",
      "title": "Alterar senha do usuário",
      "hide-footer": "",
      "centered": "",
      "size": "sm"
    }
  }, [_vm.usuarioSenhaSelecionado ? _c('div', [_c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" Usuário: "), _c('strong', [_vm._v(_vm._s(_vm.usuarioSenhaSelecionado.nome || _vm.usuarioSenhaSelecionado.usuario))])]), _c('b-form-group', {
    attrs: {
      "label": "Nova senha",
      "label-for": "nova-senha-usuario"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nova-senha-usuario",
      "type": "password",
      "autocomplete": "new-password",
      "minlength": "4",
      "maxlength": "72",
      "placeholder": "Mínimo de 4 caracteres"
    },
    model: {
      value: _vm.formSenha.password,
      callback: function callback($$v) {
        _vm.$set(_vm.formSenha, "password", $$v);
      },
      expression: "formSenha.password"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Confirmar nova senha",
      "label-for": "confirmar-senha-usuario"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "confirmar-senha-usuario",
      "type": "password",
      "autocomplete": "new-password",
      "minlength": "4",
      "maxlength": "72"
    },
    model: {
      value: _vm.formSenha.password_confirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.formSenha, "password_confirmation", $$v);
      },
      expression: "formSenha.password_confirmation"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.salvandoSenha
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-alterar-senha-usuario');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.salvandoSenha
    },
    on: {
      "click": _vm.salvarSenhaUsuario
    }
  }, [_vm.salvandoSenha ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.salvandoSenha ? "Salvando..." : "Salvar nova senha") + " ")], 1)], 1)], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modal-alterar-plano",
      "title": "Alterar plano",
      "hide-footer": "",
      "centered": ""
    }
  }, [_vm.clientePlanoSelecionado ? _c('div', [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Cliente: "), _c('strong', [_vm._v(_vm._s(_vm.clientePlanoSelecionado.nome))])]), _c('b-form-group', {
    attrs: {
      "label": "Selecione o novo plano"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.opcoesPlanos
    },
    model: {
      value: _vm.formPlano.id_plan,
      callback: function callback($$v) {
        _vm.$set(_vm.formPlano, "id_plan", $$v);
      },
      expression: "formPlano.id_plan"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Data de validade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.formPlano.data_validade,
      callback: function callback($$v) {
        _vm.$set(_vm.formPlano, "data_validade", $$v);
      },
      expression: "formPlano.data_validade"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.salvandoPlano
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-alterar-plano');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.salvandoPlano
    },
    on: {
      "click": _vm.salvarPlano
    }
  }, [_vm.salvandoPlano ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.salvandoPlano ? "Salvando..." : "Salvar") + " ")], 1)], 1)], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modal-mensal-revenda",
      "title": "Assinatura mensal da revenda",
      "hide-footer": "",
      "centered": ""
    }
  }, [_vm.revendaMensalSelecionada ? _c('div', [_c('p', [_vm._v("Revenda: "), _c('strong', [_vm._v(_vm._s(_vm.revendaMensalSelecionada.nome))])]), _c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.revendaMensalHabilitada,
      callback: function callback($$v) {
        _vm.revendaMensalHabilitada = $$v;
      },
      expression: "revendaMensalHabilitada"
    }
  }, [_vm._v(" Permitir que esta revenda renove seus clientes mensalmente por PIX ")]), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-mensal-revenda');
      }
    }
  }, [_vm._v("Cancelar")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.salvandoRevendaMensal
    },
    on: {
      "click": _vm.salvarMensalRevenda
    }
  }, [_vm._v(" " + _vm._s(_vm.salvandoRevendaMensal ? 'Salvando...' : 'Salvar') + " ")])], 1)], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modal-apps-licenca",
      "title": _vm.clienteAppsSelecionado ? 'Apps do cliente — ' + _vm.clienteAppsSelecionado.nome : 'Apps do cliente',
      "hide-footer": "",
      "centered": "",
      "size": "lg"
    }
  }, [!_vm.appsClienteSelecionado.length ? _c('div', {
    staticClass: "empty-apps-state"
  }, [_vm._v(" Nenhum app ativo para este cliente. ")]) : _c('div', {
    staticClass: "apps-detail-list"
  }, _vm._l(_vm.appsClienteSelecionado, function (app, idx) {
    return _c('div', {
      key: "".concat(idx, "-").concat(app.feature_code || app.code || app.nome || app.name),
      staticClass: "apps-detail-item"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.nomeAppDetalheLicenca(app)))]), _c('div', {
      staticClass: "apps-detail-meta"
    }, [_vm._v(" " + _vm._s(_vm.tipoAppDetalheLicenca(app)) + " ")]), _c('div', {
      staticClass: "apps-detail-meta"
    }, [_vm._v(" Origem: " + _vm._s(_vm.origemAppDetalheLicenca(app)) + " ")])]), _c('div', {
      staticClass: "apps-detail-price"
    }, [_vm._v(_vm._s(_vm.valorAppDetalheLicenca(app)))])]);
  }), 0)]), _c('b-modal', {
    attrs: {
      "id": "modal-saldo-apps-revenda",
      "title": _vm.revendaSaldoSelecionada ? 'Saldo de Apps — ' + _vm.revendaSaldoSelecionada.nome : 'Saldo de Apps',
      "hide-footer": "",
      "centered": "",
      "size": "lg"
    }
  }, [_c('div', {
    staticClass: "saldo-apps-modal"
  }, [_vm.revendaSaldoSelecionada ? _c('div', {
    staticClass: "saldo-apps-header mb-3"
  }, [_c('div', [_c('span', {
    staticClass: "saldo-apps-label"
  }, [_vm._v("Revenda:")]), _c('strong', [_vm._v(_vm._s(_vm.revendaSaldoSelecionada.nome))])]), _c('div', [_c('span', {
    staticClass: "saldo-apps-label"
  }, [_vm._v("CNPJ/CPF:")]), _c('strong', [_vm._v(_vm._s(_vm.documentoRevendaSaldoSelecionada))])])]) : _vm._e(), _c('div', {
    staticClass: "saldo-cards-grid"
  }, [_c('div', {
    staticClass: "saldo-card-item"
  }, [_c('span', [_vm._v("Saldo disponível")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoedaLicenca(_vm.saldoAppsRevenda.disponivel)))])]), _c('div', {
    staticClass: "saldo-card-item"
  }, [_c('span', [_vm._v("Saldo usado")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoedaLicenca(_vm.saldoAppsRevenda.usado)))])]), _c('div', {
    staticClass: "saldo-card-item"
  }, [_c('span', [_vm._v("Total creditado")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoedaLicenca(_vm.saldoAppsRevenda.creditado)))])])]), _c('div', {
    staticClass: "saldo-credit-form mt-3"
  }, [_c('h6', {
    staticClass: "mb-2"
  }, [_vm._v("Adicionar crédito")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "placeholder": "0,00"
    },
    model: {
      value: _vm.formCreditoApps.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.formCreditoApps, "valor", $$v);
      },
      expression: "formCreditoApps.valor"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Observação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Motivo do crédito"
    },
    model: {
      value: _vm.formCreditoApps.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.formCreditoApps, "observacao", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formCreditoApps.observacao"
    }
  })], 1)], 1)], 1), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.salvandoCreditoApps || !_vm.revendaSaldoSelecionada
    },
    on: {
      "click": _vm.adicionarCreditoAppsRevenda
    }
  }, [_vm.salvandoCreditoApps ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.salvandoCreditoApps ? "Adicionando..." : "Adicionar crédito") + " ")], 1)], 1), _c('div', {
    staticClass: "saldo-extrato mt-4"
  }, [_c('h6', {
    staticClass: "mb-2"
  }, [_vm._v("Extrato de movimentações")]), _vm.loadingSaldoAppsRevenda ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Carregando saldo da revenda... ")]) : _vm.erroSaldoAppsRevenda ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.erroSaldoAppsRevenda) + " ")]) : !_vm.extratoSaldoAppsRevenda.length ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Nenhuma movimentação encontrada. ")]) : _c('div', {
    staticClass: "table-responsive saldo-extrato-table-wrap"
  }, [_c('table', {
    staticClass: "table table-sm saldo-extrato-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Descrição")]), _c('th', [_vm._v("Valor")]), _c('th', [_vm._v("Saldo após")])])]), _c('tbody', _vm._l(_vm.extratoSaldoAppsRevenda, function (mov, idx) {
    var _ref6, _ref7, _mov$amount, _ref8, _ref9, _mov$balance_after;
    return _c('tr', {
      key: "mov_".concat(idx)
    }, [_c('td', [_vm._v(_vm._s(_vm.formatarDataMovimentacaoSaldo(mov.created_at || mov.data_movimentacao || mov.date)))]), _c('td', [_vm._v(_vm._s(_vm.textoTipoMovimentacaoSaldo(mov)))]), _c('td', [_vm._v(_vm._s(mov.description || mov.descricao || mov.observacao || mov.observation || "Sem descrição"))]), _c('td', [_c('span', {
      staticClass: "saldo-mov-valor",
      class: _vm.classeValorMovimentacaoSaldo(mov)
    }, [_vm._v(" " + _vm._s(_vm.sinalValorMovimentacaoSaldo(mov)) + " " + _vm._s(_vm.formatarMoedaLicenca((_ref6 = (_ref7 = (_mov$amount = mov.amount) !== null && _mov$amount !== void 0 ? _mov$amount : mov.valor) !== null && _ref7 !== void 0 ? _ref7 : mov.value) !== null && _ref6 !== void 0 ? _ref6 : 0)) + " ")])]), _c('td', [_vm._v(_vm._s(_vm.formatarMoedaLicenca((_ref8 = (_ref9 = (_mov$balance_after = mov.balance_after) !== null && _mov$balance_after !== void 0 ? _mov$balance_after : mov.saldo_apos) !== null && _ref9 !== void 0 ? _ref9 : mov.balanceAfter) !== null && _ref8 !== void 0 ? _ref8 : 0)))])]);
  }), 0)])])])])]), _c('b-modal', {
    attrs: {
      "id": "modal-upload-pdv-offline",
      "title": _vm.revendaUploadPdvSelecionada ? 'Upload PDV Offline — ' + _vm.revendaUploadPdvSelecionada.nome : 'Upload PDV Offline',
      "hide-footer": "",
      "centered": ""
    }
  }, [_vm.revendaUploadPdvSelecionada ? _c('div', [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Revenda: "), _c('strong', [_vm._v(_vm._s(_vm.revendaUploadPdvSelecionada.nome))])]), _c('b-form-group', {
    attrs: {
      "label": "Nome do arquivo",
      "label-for": "upload-pdv-nome-arquivo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "upload-pdv-nome-arquivo",
      "placeholder": "Ex: Nuts-PDV-Desktop-parceiro.exe"
    },
    model: {
      value: _vm.formUploadPdv.nome_arquivo,
      callback: function callback($$v) {
        _vm.$set(_vm.formUploadPdv, "nome_arquivo", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formUploadPdv.nome_arquivo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Arquivo do instalador (.exe)",
      "label-for": "upload-pdv-arquivo"
    }
  }, [_c('b-form-file', {
    attrs: {
      "id": "upload-pdv-arquivo",
      "accept": ".exe",
      "placeholder": "Selecione o instalador .exe..."
    },
    on: {
      "change": _vm.setArquivoUploadPdv
    }
  })], 1), _vm.erroUploadPdv ? _c('div', {
    staticClass: "text-danger font-weight-bold mb-3"
  }, [_vm._v(" " + _vm._s(_vm.erroUploadPdv) + " ")]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.enviandoUploadPdv
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-upload-pdv-offline');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.enviandoUploadPdv || !_vm.formUploadPdv.arquivo
    },
    on: {
      "click": _vm.enviarUploadPdvOffline
    }
  }, [_vm.enviandoUploadPdv ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.enviandoUploadPdv ? "Enviando..." : "Enviar") + " ")], 1)], 1)], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modal-features-empresa",
      "title": _vm.empresaFeaturesSelecionada ? 'Gerenciar Apps — ' + _vm.empresaFeaturesSelecionada.nome : 'Gerenciar Apps',
      "hide-footer": "",
      "centered": "",
      "size": "xl"
    }
  }, [_c('div', {
    staticClass: "feature-admin-modal"
  }, [_c('div', {
    staticClass: "feature-admin-header mb-3"
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v(" Cliente: "), _c('strong', [_vm._v(_vm._s(_vm.empresaFeaturesSelecionada ? _vm.empresaFeaturesSelecionada.nome : "Não informado"))])]), _c('p', {
    staticClass: "mb-1"
  }, [_vm._v(" CNPJ/CPF: "), _c('strong', [_vm._v(_vm._s(_vm.documentoEmpresaSelecionada))])]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" Plano atual: "), _c('strong', [_vm._v(_vm._s(_vm.planoAtualEmpresaSelecionada))])])]), _c('div', {
    staticClass: "alert alert-light-warning py-2 px-3 mb-3"
  }, [_vm._v(" Esta liberação é administrativa e não gera cobrança automática. ")]), _c('div', {
    staticClass: "feature-admin-content"
  }, [_vm.loadingFeatures ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Carregando..."
    }
  }), _c('p', {
    staticClass: "mt-3 text-muted"
  }, [_vm._v("Carregando módulos e plugins...")])], 1) : _vm.erroFeatures ? _c('div', {
    staticClass: "text-center py-5 text-muted"
  }, [_vm._v(" " + _vm._s(_vm.erroFeatures) + " ")]) : !_vm.featuresFiltradas.length ? _c('div', {
    staticClass: "text-center py-5 text-muted"
  }, [_vm._v(" Nenhum módulo ou plugin encontrado para sua busca. ")]) : _c('div', [_vm.featuresAgrupadas.modules.length ? _c('div', {
    staticClass: "mb-4"
  }, [_c('h6', {
    staticClass: "feature-admin-group-title"
  }, [_vm._v("Módulos")]), _c('div', {
    staticClass: "feature-grid"
  }, _vm._l(_vm.featuresAgrupadas.modules, function (feature) {
    return _c('div', {
      key: feature.code,
      staticClass: "feature-admin-item border rounded",
      class: {
        ativo: feature.active,
        'em-breve': _vm.isComingSoon(feature)
      }
    }, [_c('div', {
      staticClass: "feature-item-top"
    }, [_c('div', {
      staticClass: "d-flex align-items-start feature-admin-main"
    }, [_c('b-form-checkbox', {
      staticClass: "mr-3 mt-1",
      attrs: {
        "switch": "",
        "disabled": _vm.isComingSoon(feature)
      },
      on: {
        "change": function change($event) {
          return _vm.aoAlterarFeatureAtiva(feature);
        }
      },
      model: {
        value: feature.active,
        callback: function callback($$v) {
          _vm.$set(feature, "active", $$v);
        },
        expression: "feature.active"
      }
    }), _c('div', {
      staticClass: "feature-admin-body"
    }, [_c('div', {
      staticClass: "d-flex align-items-center flex-wrap mb-1"
    }, [_c('h6', {
      staticClass: "mb-0 mr-2 font-weight-bold"
    }, [_vm._v(" " + _vm._s(feature.name) + " ")]), _c('span', {
      staticClass: "label label-inline mr-2 label-light-success"
    }, [_vm._v(" Módulo ")]), _vm.isComingSoon(feature) ? _c('span', {
      staticClass: "label label-inline mr-2 label-warning em-breve-badge"
    }, [_vm._v(" Em breve ")]) : _vm._e(), feature.active ? _c('span', {
      staticClass: "label label-inline label-light-primary"
    }, [_vm._v(" Ativo ")]) : _vm._e()]), _c('p', {
      staticClass: "text-muted mb-2 feature-description"
    }, [_vm._v(" " + _vm._s(feature.description || "Sem descrição cadastrada.") + " ")]), _c('div', {
      staticClass: "feature-admin-meta"
    }, [_c('span', [_vm._v(" Valor referência: "), _c('strong', [_vm._v(_vm._s(_vm.formatarValorMensalFeature(feature)))])]), _c('span', [_vm._v(" Cobrança: "), _c('strong', [_vm._v(_vm._s(_vm.textoBillingMode(feature.billing_mode)))])]), feature.active ? _c('span', [_c('span', {
      staticClass: "feature-source-badge",
      class: _vm.classeSourceFeature(feature.source)
    }, [_vm._v(" " + _vm._s(_vm.textoSourceFeature(feature.source)) + " ")])]) : _vm._e()]), _c('div', {
      staticClass: "feature-admin-controls mt-3"
    }, [_c('b-form-group', {
      staticClass: "mb-2",
      attrs: {
        "label": "Tipo de liberação",
        "label-class": "mb-1"
      }
    }, [_c('b-form-select', {
      attrs: {
        "disabled": _vm.isComingSoon(feature) || !feature.active,
        "options": _vm.opcoesLiberacaoFeatures
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarLiberacaoFeature(feature);
        }
      },
      model: {
        value: feature.tipo_liberacao,
        callback: function callback($$v) {
          _vm.$set(feature, "tipo_liberacao", $$v);
        },
        expression: "feature.tipo_liberacao"
      }
    })], 1), _c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v(" " + _vm._s(_vm.descricaoLiberacaoFeature(feature)) + " ")]), feature.renewal_behavior === 'charge_on_renewal' ? _c('small', {
      staticClass: "text-warning d-block mt-1"
    }, [_vm._v(" Na renovação, o cliente deverá contratar para continuar usando. ")]) : _vm._e()], 1)])], 1)])]);
  }), 0)]) : _vm._e(), _vm.featuresAgrupadas.plugins.length ? _c('div', {
    staticClass: "mb-2"
  }, [_c('h6', {
    staticClass: "feature-admin-group-title"
  }, [_vm._v("Plugins")]), _c('div', {
    staticClass: "feature-grid"
  }, _vm._l(_vm.featuresAgrupadas.plugins, function (feature) {
    return _c('div', {
      key: feature.code,
      staticClass: "feature-admin-item border rounded",
      class: {
        ativo: feature.active,
        'em-breve': _vm.isComingSoon(feature)
      }
    }, [_c('div', {
      staticClass: "feature-item-top"
    }, [_c('div', {
      staticClass: "d-flex align-items-start feature-admin-main"
    }, [_c('b-form-checkbox', {
      staticClass: "mr-3 mt-1",
      attrs: {
        "switch": "",
        "disabled": _vm.isComingSoon(feature)
      },
      on: {
        "change": function change($event) {
          return _vm.aoAlterarFeatureAtiva(feature);
        }
      },
      model: {
        value: feature.active,
        callback: function callback($$v) {
          _vm.$set(feature, "active", $$v);
        },
        expression: "feature.active"
      }
    }), _c('div', {
      staticClass: "feature-admin-body"
    }, [_c('div', {
      staticClass: "d-flex align-items-center flex-wrap mb-1"
    }, [_c('h6', {
      staticClass: "mb-0 mr-2 font-weight-bold"
    }, [_vm._v(" " + _vm._s(feature.name) + " ")]), _c('span', {
      staticClass: "label label-inline mr-2 label-light-primary"
    }, [_vm._v(" Plugin ")]), _vm.isComingSoon(feature) ? _c('span', {
      staticClass: "label label-inline mr-2 label-warning em-breve-badge"
    }, [_vm._v(" Em breve ")]) : _vm._e(), feature.active ? _c('span', {
      staticClass: "label label-inline label-light-primary"
    }, [_vm._v(" Ativo ")]) : _vm._e()]), _c('p', {
      staticClass: "text-muted mb-2 feature-description"
    }, [_vm._v(" " + _vm._s(feature.description || "Sem descrição cadastrada.") + " ")]), _c('div', {
      staticClass: "feature-admin-meta"
    }, [_c('span', [_vm._v(" Valor referência: "), _c('strong', [_vm._v(_vm._s(_vm.formatarValorMensalFeature(feature)))])]), _c('span', [_vm._v(" Cobrança: "), _c('strong', [_vm._v(_vm._s(_vm.textoBillingMode(feature.billing_mode)))])]), feature.active ? _c('span', [_c('span', {
      staticClass: "feature-source-badge",
      class: _vm.classeSourceFeature(feature.source)
    }, [_vm._v(" " + _vm._s(_vm.textoSourceFeature(feature.source)) + " ")])]) : _vm._e()]), feature.billing_mode === 'per_quantity' ? _c('div', {
      staticClass: "feature-quantity mt-3"
    }, [_c('span', {
      staticClass: "feature-quantity-label"
    }, [_vm._v(" " + _vm._s(feature.code === "PLG_MULTIEMPRESA" ? "Limite de empresas no grupo" : "Quantidade") + " ")]), _c('div', {
      staticClass: "feature-quantity-controls"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light-primary",
      attrs: {
        "type": "button",
        "disabled": _vm.isComingSoon(feature) || !feature.active || feature.quantity <= feature.min_quantity
      },
      on: {
        "click": function click($event) {
          return _vm.alterarQuantidadeFeature(feature, -1);
        }
      }
    }, [_vm._v(" - ")]), _c('span', {
      staticClass: "feature-quantity-value"
    }, [_vm._v(_vm._s(feature.quantity))]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary",
      attrs: {
        "type": "button",
        "disabled": _vm.isComingSoon(feature) || !feature.active || feature.quantity >= feature.max_quantity
      },
      on: {
        "click": function click($event) {
          return _vm.alterarQuantidadeFeature(feature, 1);
        }
      }
    }, [_vm._v(" + ")])]), _c('div', {
      staticClass: "text-muted mt-2"
    }, [_vm._v(" Total referência: "), _c('strong', [_vm._v(_vm._s(_vm.formatarTotalFeature(feature)))])])]) : _vm._e(), _c('div', {
      staticClass: "feature-admin-controls mt-3"
    }, [_c('b-form-group', {
      staticClass: "mb-2",
      attrs: {
        "label": "Tipo de liberação",
        "label-class": "mb-1"
      }
    }, [_c('b-form-select', {
      attrs: {
        "disabled": _vm.isComingSoon(feature) || !feature.active,
        "options": _vm.opcoesLiberacaoFeatures
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarLiberacaoFeature(feature);
        }
      },
      model: {
        value: feature.tipo_liberacao,
        callback: function callback($$v) {
          _vm.$set(feature, "tipo_liberacao", $$v);
        },
        expression: "feature.tipo_liberacao"
      }
    })], 1), _c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v(" " + _vm._s(_vm.descricaoLiberacaoFeature(feature)) + " ")])], 1)])], 1)])]);
  }), 0)]) : _vm._e()])]), _c('div', {
    staticClass: "feature-admin-footer"
  }, [_c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.resumoAppsAtivos) + " apps ativos")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Total referência: "), _c('strong', [_vm._v(_vm._s(_vm.totalReferenciaFormatado))])])]), _c('div', {
    staticClass: "feature-admin-actions"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.salvandoFeatures
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-features-empresa');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.salvandoFeatures || _vm.loadingFeatures || !!_vm.erroFeatures
    },
    on: {
      "click": _vm.salvarFeatures
    }
  }, [_vm.salvandoFeatures ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.salvandoFeatures ? "Salvando alterações..." : "Salvar alterações") + " ")], 1)], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "modal-uso-empresa",
      "title": _vm.empresaUsoSelecionada ? 'Análise de Uso — ' + _vm.empresaUsoSelecionada.nome : 'Análise de Uso',
      "hide-footer": "",
      "centered": "",
      "size": "lg"
    }
  }, [_vm.loadingUso ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Carregando..."
    }
  }), _c('p', {
    staticClass: "mt-3 text-muted"
  }, [_vm._v("Carregando dados de uso...")])], 1) : _vm.usoEmpresa ? _c('div', [_c('div', {
    staticClass: "rounded p-4 mb-4 text-center",
    style: {
      background: _vm.temperaturaUso.tipo === 'quente' ? 'linear-gradient(135deg, #ff6b35, #f7c59f)' : _vm.temperaturaUso.tipo === 'morno' ? 'linear-gradient(135deg, #f7b731, #ffe082)' : 'linear-gradient(135deg, #2980b9, #a8d8ea)',
      color: _vm.temperaturaUso.tipo === 'frio' ? '#fff' : '#333'
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "48px",
      "line-height": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.temperaturaUso.tipo === "quente" ? "🔥" : _vm.temperaturaUso.tipo === "morno" ? "🌤️" : "❄️") + " ")]), _c('h4', {
    staticClass: "mt-2 mb-1 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.temperaturaUso.tipo === "quente" ? "Cliente Quente" : _vm.temperaturaUso.tipo === "morno" ? "Cliente Morno" : "Cliente Frio") + " ")]), _c('p', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm.temperaturaUso.dias === null ? [_vm._v("Sem atividade registrada")] : _vm.temperaturaUso.dias === 0 ? [_vm._v("Ativo hoje!")] : [_vm._v("Última atividade há " + _vm._s(_vm.temperaturaUso.dias) + " dia(s)")]], 2), _c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "progress",
    staticStyle: {
      "height": "14px",
      "border-radius": "7px",
      "background": "rgba(255, 255, 255, 0.35)"
    }
  }, [_c('div', {
    staticClass: "progress-bar bg-white",
    style: {
      width: _vm.temperaturaScore + '%'
    },
    attrs: {
      "role": "progressbar"
    }
  })]), _c('div', {
    staticClass: "d-flex justify-content-between mt-1",
    staticStyle: {
      "font-size": "11px"
    }
  }, [_c('span', [_vm._v("❄️ Inativo")]), _c('span', [_vm._v("Score de Uso: " + _vm._s(_vm.temperaturaScore) + "%")]), _c('span', [_vm._v("🔥 Muito Ativo")])])])]), _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.metricasUso, function (item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-md-6 mb-3"
    }, [_c('div', {
      staticClass: "card border shadow-sm h-100"
    }, [_c('div', {
      staticClass: "card-body p-3 d-flex align-items-center"
    }, [_c('span', {
      staticStyle: {
        "font-size": "26px",
        "min-width": "38px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.icone))]), _c('div', {
      staticClass: "ml-3"
    }, [_c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "11px",
        "text-transform": "uppercase",
        "letter-spacing": "0.5px"
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]), item.valor ? _c('div', [_c('span', {
      staticClass: "font-weight-bold",
      class: item.dias <= 7 ? 'text-success' : item.dias <= 30 ? 'text-warning' : 'text-danger'
    }, [_vm._v(" " + _vm._s(_vm.diasDesde(item.valor)) + " ")]), _c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatUsoDt(item.valor)) + " ")])]) : _c('div', {
      staticClass: "text-muted font-weight-bold",
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v(" Nunca utilizado ")])])])])]);
  }), 0)]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };